<script>
import MainMenuStudentView from '../../../shared/views/MainMenuStudentView';
import ListCourseExploreView from '../lists/ListCourseExploreView';
import PermissionHelper from '../../../../core/shared/helpers/PermissionHelper';

export default {
  name: 'ModuleCoursesExploreView',
  components: {
    'main-menu-student-view': MainMenuStudentView,
    'list-courses-explore-view': ListCourseExploreView,
  },
  data() {
    return {};
  },
  methods: {
    onCanShow(moduleName) {
      return PermissionHelper.canShow(moduleName);
    },
  },
};
</script>

<template>
  <div>
    <main-menu-student-view />
    <div class="wrapper">
      <div class="sa4d25">
        <div class="container-fluid">
          <div class="section3125">
            <!-- Encabezado de página Appmisionate -->
            <div class="stream_page_header">
              <div class="stream_header_left">
                <div class="stream_header_icon">
                  <i class="uil uil-book-open" />
                </div>
                <div class="stream_header_text">
                  <h4 class="item_title">
                    Todos los Cursos
                  </h4>
                  <p class="stream_header_subtitle">
                    Explora nuestro catálogo académico, contenidos estructurados y material de preparación
                  </p>
                </div>
              </div>
              <div class="stream_header_right">
                <span class="stream_live_pill">
                  <i class="uil uil-graduation-cap" /> Formación Continua
                </span>
              </div>
            </div>

            <!-- Contenido del catálogo -->
            <div class="la5lo1">
              <list-courses-explore-view />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
